import { UploadProcessObjectFileFormSchema } from './schemas';
import { PROCESS_OBJECTS_ROOT_API_URL } from '@/routes/process-objects/list/constants';
import apiClient from '@/api';

export function uploadProcessObjectFile(data: UploadProcessObjectFileFormSchema) {
	const payload = new FormData();
	payload.append('title', data.title);
	payload.append('description', data.description);
	for (const file of data.files) {
		payload.append('file', file);
	}
	return apiClient.post(PROCESS_OBJECTS_ROOT_API_URL + '/' + data.processObjectId + '/files', payload);
}

export function updateProcessObjectFile(processObjectId: number, fileId: number, file: File) {
	const payload = new FormData();
	payload.append('file', file);
	return apiClient.put(
		`${PROCESS_OBJECTS_ROOT_API_URL}/${processObjectId}/files/${fileId}`,
		payload
	);
}